"use client";

import { Line } from "recharts";
import {
  lineSeriesProps,
  resolveSeriesColor,
  seriesLineStyle,
} from "@/utils";

export type ExploreChartLine = {
  dataKey: string;
  name: string;
  stroke?: string;
};

/**
 * Recharts only discovers <Line /> elements that are direct children of
 * <LineChart /> — not when wrapped in a custom component. Call this inside
 * LineChart JSX: `{exploreChartLines(lines, hidden)}`
 */
export function exploreChartLines(
  lines: ExploreChartLine[],
  hidden: string[],
) {
  return lines.map((props, seriesIndex) => {
    const stroke = resolveSeriesColor(
      props.dataKey,
      props.name,
      seriesIndex,
    );
    return (
      <Line
        key={props.dataKey}
        {...lineSeriesProps}
        {...props}
        stroke={stroke}
        style={seriesLineStyle(stroke)}
        hide={hidden.includes(props.dataKey)}
      />
    );
  });
}

/** @deprecated Use exploreChartLines() as a function inside LineChart. */
export const ExploreChartLines = exploreChartLines;

export default exploreChartLines;
